import React from 'react';

// Marketplace "publisher" = the agency that created a listing. The API resolves the name
// (MyToolModel.publisherName / Toolbox module.publisher); these helpers give every catalog view
// the same filter options and dropdown, so MyTools Browse/Installed and Toolbox stay consistent.

/** Filter value meaning "no publisher filter". */
export const ALL_PUBLISHERS = '';

/** Distinct, non-empty publisher names, sorted case-insensitively. */
export function publisherOptions(names: Array<string | null | undefined>): string[] {
    const seen = new Map<string, string>();
    for (const raw of names) {
        const name = (raw ?? '').trim();
        if (name && !seen.has(name.toLowerCase()))
            seen.set(name.toLowerCase(), name);
    }
    return Array.from(seen.values()).sort((a, b) => a.localeCompare(b, undefined, { sensitivity: 'base' }));
}

/** True when `name` passes the selected publisher filter. */
export function matchesPublisher(name: string | null | undefined, selected: string): boolean {
    if (!selected)
        return true;
    return (name ?? '').trim().toLowerCase() === selected.trim().toLowerCase();
}

export const PublisherFilterSelect: React.FC<{
    value: string;
    options: string[];
    onChange: (value: string) => void;
    className?: string;
}> = ({ value, options, onChange, className }) => {
    // A filter with one choice does nothing — hide it, unless a (now-stale) value is still applied
    // so the user can clear it.
    if (options.length < 2 && !value)
        return null;
    const list = value && !options.some(o => o.toLowerCase() === value.toLowerCase()) ? [value, ...options] : options;
    return (<select className={className} value={value} onChange={e => onChange(e.target.value)} aria-label="Filter by publisher">
      <option value={ALL_PUBLISHERS}>All Publishers</option>
      {list.map(name => (<option key={name} value={name}>{name}</option>))}
    </select>);
};
